import { useSwipeable } from "react-swipeable";
import close from '../../assets/images/close.png';
import styles from './PhotoModal.module.css';

const PhotoModal = (props) => {
    const swipeHandlers = useSwipeable({
		onSwipedLeft: props.rightKeyDown,
		onSwipedRight: props.leftKeyDown,
		preventScrollOnSwipe: true,
		trackTouch: true
	});

    return (
        <div className={styles.modal}>
            <div className={styles.container}>
                <img className={styles.close} src={close} alt="Close" onClick={props.close}/>
                <img className={styles.image} src={props.url} alt="Image" {...swipeHandlers}/>
            </div>
        </div>
    )
};

export default PhotoModal;